<template>
    <div class="page">
        <div class="gridheader">
            <div class="row wrapper">
                <div class="col-md-2"></div>
                <div class="col-md-8 search-form">
                    <form method="get" action="">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>{{$t('MONTH')}}</label>
                                    <select v-model="params.month" class="form-control secondary">
                                        <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>{{$t('YEAR')}}</label>
                                    <select v-model="params.year" class="form-control secondary">
                                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3" v-if="globals.auth == 9">
                                <div class="form-group">
                                    <label>{{$t('COMPANY')}}</label>
                                    <select v-model="params.ordererCompanyId" class="form-control secondary">
                                        <option v-for="company in companies.root" :value="company.companyId" :key="company.companyId">{{ company.companyName }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3 action">
                                <router-link :to="{ path: '/printdsclientreport/', query: getQueryParams }" class="btn btn-white d-none d-md-block"><img src="../assets/img/icon-print.svg" alt=""> {{ $t('PRINT')}}</router-link>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div>
        <div class="row reports report-monthly">
            <div class="table-responsive">
                <table class="maintable reports">
                    <thead>
                        <tr>
                            <td>{{$t('DATETIME')}}</td>
                            <td>{{$t('PRODUCT')}}</td>
                            <td>{{$t('QUANTITY')}}</td>
                            <td>{{$t('ISREPEAT')}}</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, i) in report.root" :key="i">
                            <td>{{formatDate(row.updateDateTime)}}</td>
                            <td>{{$t(row.name)}}</td>
                            <td>{{row.num}}</td>
                            <td>{{row.isRepeat}}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="table-responsive">
                <table class="maintable reports">
                    <thead>
                        <tr>
                            <td></td>
                            <td v-for="product in report.products">{{$t(product.name)}}</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{$t('QUANTITY')}}:</td>
                            <td v-for="product in report.products">{{product.num}}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>{{$t('REPEATNUM')}}:</td>
                            <td v-for="product in report.products">{{product.isRepeat}}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import
{
    mapActions,
    mapGetters
}
from 'vuex'
import dentalsolutiontypesApi from '@/api/dentalsolutiontypes'
import dentalsolutionsApi from '@/api/dentalsolutions'
import moment from 'moment';

export default
{
    name: 'ReportsDs',
    data: function()
    {
        return {
            dentalsolutiontypes: {
                root: [],
                totalCount: 0
            },
            companies: {
                root: [],
                totalCount: 0
            },
            report: {
                root: [],
                totalCount: 0,
            },
            params:
            {
                month: moment().format('M'),
                year: moment().format('YYYY'),
                ordererCompanyId: '',
            }
        };
    },
    created: function()
    {
        var me = this;

        me.getCompanies();
        me.getDentalSolutionTypes();
        me.getClientReport();
    },
    methods:
    {
        getDentalSolutionTypes()
        {
            const me = this;
            dentalsolutiontypesApi.selectRow({}, function(data)
            {
                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.dentalsolutiontypes = Object.assign({}, data);
            });
        },
        getCompanies()
        {
            var me = this;
            dentalsolutionsApi.selectDentalSolutionUsers({}, function(data)
            {
                if (data.error)
                {
                    me.$notify.error(data.notice);
                }
                else
                {
                    me.companies = data;
                }
            });
        },
        setCompanyId(val)
        {
            var me = this;
            me.params.companyId = val;
        },
        getClientReport()
        {
            var me = this;
            const params = { ...me.params };

            params.date = moment(params.date).format('YYYY-MM-DD');

            dentalsolutionsApi.getClientReport(params, function(data)
            {
                if (data.error)
                {
                    me.$notify.error(data.notice);
                }
                else
                {
                    me.report = data;
                }
            });
        }
    },
    watch:
    {
        'params.date': function()
        {
            var me = this;
            me.getClientReport();
        },
        'params.ordererCompanyId': function()
        {
            var me = this;
            me.getClientReport();
        },
    },
    computed: {
        ...mapGetters([
            'globals'
        ]),
        years()
        {
            const data = [];

            for(let i=2020;i<2040;i++)
            {
                data.push(i);
            }

            return data;
        },
        months()
        {
            const data = [];

            for(let i=1;i<=12;i++)
            {
                if(String(i).length == 1)
                {
                    data.push('0'+String(i));
                }
                else
                {
                    data.push(String(i));
                }
            }

            return data;
        },
        getQueryParams()
        {
            const me = this;

            return {
                ...me.params,
                date: moment(me.params.date).format('YYYY-MM-DD')            
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ReportsDsClient.vue